import React from "react";
import Fireworks from "react-canvas-confetti/dist/presets/fireworks";

import useSurveys from "../state/hooks/useSurveys";

export default function SurveyConfetti() {
  const { showThankYou, showSurveysDialog } = useSurveys();

  if (!showThankYou || !showSurveysDialog) {
    return null;
  }

  return <Fireworks autorun={{ speed: 1 }} />;
}
